document.querySelectorAll('.formula-highlights__video-toggle').forEach((button) => {
  const wrapper = button.closest('.formula-highlights__media');
  const video = wrapper ? wrapper.querySelector('video') : null;
  if (!video) return;

  button.addEventListener('click', () => {
    if (video.paused) {
      video.play();
      button.classList.remove('is-paused');
      button.setAttribute('aria-label', 'Pause video');
    } else {
      video.pause();
      button.classList.add('is-paused');
      button.setAttribute('aria-label', 'Play video');
    }
  });
});
